import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/invitacion/:qrId',
    name: 'invitacion',
    component: () => import( '../views/InviteView.vue')
  },
  {
    path: '/escanear',
    name: 'escanear',
    component: () => import( '../views/ScanView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
